import { InjectionToken } from '@angular/core';

export const PRICES_PROVIDER_KEY = 'PricesProviderService';
export const PRICES_PROVIDER_TOKEN = new InjectionToken(PRICES_PROVIDER_KEY);
